import { PrimitiveTypes } from '../../shared/interfaces/generics';

export enum UnaryOperator {
  NOT = 'NOT',
  EXISTS = 'EXISTS'
}

export enum BinaryOperator {
  OR = 'OR',
  AND = 'AND',
  GREATER_THAN = 'GREATER_THAN',
  LESSER_THAN = 'LESSER_THAN',
  GREATER_THAN_EQUAL_TO = 'GREATER_THAN_EQUAL_TO',
  LESSER_THAN_EQUAL_TO = 'LESSER_THAN_EQUAL_TO',
  EQUALS = 'EQUALS'
}

export enum ExpressionEvaluatorType {
  IDENTIFIER = 'IDENTIFIER',
  LITERAL = 'LITERAL',
  UNARY_EXPRESSION = 'UNARY_EXPRESSION',
  BINARY_EXPRESSION = 'BINARY_EXPRESSION'
}

export type ExpressionEvaluatorSanitiseKeyFn = (key: string) => string;

export interface ExpressionEvaluator<D, V> {
  getType: () => ExpressionEvaluatorType;
  evaluate: (model: D, getSanitiseKey: ExpressionEvaluatorSanitiseKeyFn) => V;
}

export interface RenderExpressionFactoryType {
  type: ExpressionEvaluatorType;
}

export interface IdentifierExpressionFactoryData extends RenderExpressionFactoryType {
  value: string;
}

export interface LiteralExpressionFactoryData extends RenderExpressionFactoryType {
  value: PrimitiveTypes;
}

export interface UnaryExpressionFactoryData extends RenderExpressionFactoryType {
  operator: UnaryOperator;
  argument: IdentifierExpressionFactoryData | LiteralExpressionFactoryData;
}

export interface BinaryExpressionFactoryData extends RenderExpressionFactoryType {
  operator: BinaryOperator;
  left:
    | BinaryExpressionFactoryData
    | UnaryExpressionFactoryData
    | IdentifierExpressionFactoryData
    | LiteralExpressionFactoryData;
  right:
    | BinaryExpressionFactoryData
    | UnaryExpressionFactoryData
    | IdentifierExpressionFactoryData
    | LiteralExpressionFactoryData;
}
